import React, { useEffect, useState } from "react";
import axios from "axios";
import "../Styles/AdminUsers.css";

function AdminUsers({ refreshDashboard }) {

  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [role, setRole] = useState("ADMIN");

  const [admins, setAdmins] = useState([]);
  const [showUsers, setShowUsers] = useState(false);

  const [message, setMessage] = useState("");
  const [error, setError] = useState("");

  const currentAdmin = JSON.parse(
    localStorage.getItem("admin") || "null"
  );

  const loadAdmins = async () => {
    try {
      const response = await axios.get(
        "/api/admin/all"
      );

      setAdmins(response.data);

    } catch (err) {
      console.error("Error loading admins:", err);
      setError("Unable to load admin users.");
    }
  };

  useEffect(() => {
    loadAdmins();
  }, []);

  const handleAddAdmin = async (e) => {
    e.preventDefault();

    setMessage("");
    setError("");

    if (!username.trim() || !password.trim()) {
      setError("Please enter username and password.");
      return;
    }

    try {

      const response = await axios.post(
        "/api/admin/create",
        null,
        {
          params: {
            username: username.trim(),
            password: password,
            role: role
          }
        }
      );

      setMessage(
        `Admin created successfully. Admin ID: ${response.data.adminId}`
      );

      setUsername("");
      setPassword("");
      setRole("ADMIN");

      loadAdmins();

      if (refreshDashboard) {
        refreshDashboard();
      }

    } catch (err) {

      console.error("Error creating admin:", err);

      setError(
        err.response?.data ||
        "Failed to create admin."
      );
    }
  };


  const handleDeleteAdmin = async (adminId) => {

    if (!window.confirm(
      `Are you sure you want to delete admin ${adminId}?`
    )) {
      return;
    }

    setMessage("");
    setError("");

    try {

      await axios.delete(
        `/api/admin/delete/${adminId}`
      );

      setMessage("Admin deleted successfully.");

      loadAdmins();

    } catch (err) {

      console.error("Error deleting admin:", err);

      setError(
        err.response?.data ||
        "Failed to delete admin."
      );
    }
  };


  return (
    <div className="admin-users-page">

      <h2>Admin Users</h2>


      {/* ================= ADD ADMIN ================= */}

      <div className="admin-section">

        <h3>Add Admin</h3>

        <form onSubmit={handleAddAdmin}>

          <div className="admin-field">

            <label>Username</label>

            <input
              type="text"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              placeholder="Enter username"
            />

          </div>


          <div className="admin-field">

            <label>Password</label>

            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Enter password"
            />

          </div>


          <div className="admin-field">

            <label>Role</label>

            <select
              value={role}
              onChange={(e) => setRole(e.target.value)}
            >
              <option value="ADMIN">ADMIN</option>
              <option value="SUPER_ADMIN">SUPER ADMIN</option>
            </select>

          </div>


          <button
            type="submit"
            className="add-admin-button"
          >
            Add Admin
          </button>

        </form>

      </div>


      {/* ================= USER DETAILS ================= */}

      <button
        className="user-details-button"
        onClick={() => {
          setShowUsers(!showUsers);

          if (!showUsers) {
            loadAdmins();
          }
        }}
      >
        {showUsers ? "Hide User Details" : "User Details"}
      </button>


      {showUsers && (

        <div className="admin-list">

          {admins.length === 0 ? (

            <p className="no-admins">
              No admin users found.
            </p>

          ) : (

            admins.map((admin) => {

              const isCurrentUser =
                currentAdmin &&
                currentAdmin.adminId === admin.adminId;

              const canDelete =
                currentAdmin &&
                currentAdmin.role === "SUPER_ADMIN" &&
                !isCurrentUser;

              return (

                <div
                  className="admin-list-item"
                  key={admin.id}
                >

                  <div className="admin-details">

                    <span>
                      <strong>ID:</strong>{" "}
                      {admin.adminId}
                    </span>

                    <span>
                      <strong>Name:</strong>{" "}
                      {admin.username}
                    </span>

                    <span>
                      <strong>Role:</strong>{" "}
                      {admin.role === "SUPER_ADMIN"
                        ? "SUPER ADMIN"
                        : admin.role}
                    </span>

                  </div>


                  {/* DELETE ICON */}

                  {canDelete && (

                    <button
                      className="delete-admin-button"
                      onClick={() =>
                        handleDeleteAdmin(admin.adminId)
                      }
                      title="Delete Admin"
                    >
                      🗑️
                    </button>

                  )}

                </div>

              );
            })

          )}

        </div>

      )}


      {/* ================= MESSAGES ================= */}

      {message && (
        <p className="admin-success">
          {message}
        </p>
      )}

      {error && (
        <p className="admin-error">
          {error}
        </p>
      )}

    </div>
  );
}

export default AdminUsers;